import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { ButtonFilled, ButtonTonal } from '@snack-uikit/button';
import { TEST_IDS } from '../../constants';
import { useInfoBlockContext } from '../../contexts';
import { useButtonWithTooltip } from './hooks';
import styles from './styles.module.css';
export function Footer({ primaryButton, secondaryButton, className }) {
    const PrimaryButton = useButtonWithTooltip({ Button: ButtonFilled, tooltip: primaryButton.tooltip });
    const SecondaryButton = useButtonWithTooltip({ Button: ButtonTonal, tooltip: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.tooltip });
    const { size } = useInfoBlockContext();
    return (_jsxs("div", { className: cn(styles.infoBlockFooter, className), children: [secondaryButton && (_jsx(SecondaryButton, Object.assign({}, secondaryButton, { size: size, "data-test-id": secondaryButton['data-test-id'] || TEST_IDS.secondaryButton }))), _jsx(PrimaryButton, Object.assign({}, primaryButton, { size: size, "data-test-id": primaryButton['data-test-id'] || TEST_IDS.primaryButton }))] }));
}
